<template>
  <div id="modalBodyScroll">
     <table id="modalBodyTable">
      <tbody>
        <tr>
          <td>Controlled Intersection</td>
          <td>{{ crosswalk.atControlledIntersection }}</td>
        </tr>
        <tr>
          <td>Crosses Major Street</td>
          <td>{{ crosswalk.crossesMajorStreet }}</td>
        </tr>
        <tr>
          <td>Speed Limit (MPH)</td>
          <td>{{ crosswalk.speedLimit }}</td>
        </tr>
        <tr>
          <td>Crosswalk Signage</td>
          <td>{{ crosswalk.crosswalkSignage }}</td>
        </tr>
        <tr>
          <td>Tactile Indicators</td>
          <td>{{ crosswalk.tactileIndicators }}</td>
        </tr>
        <tr>
          <td>School Zone</td>
          <td>{{ crosswalk.schoolZone }}</td>
        </tr>
      </tbody>
    </table>
    <div id="notesSection">
      <div id="notesHeader">Notes</div>
      <div id="notesText">{{ crosswalk.notes }}</div>
    </div>
    <div class="bodyContentSection">
      <div class="bodyContentSectionHeader">Last Edited</div>
      <div class="bodyContentSectionField">{{ lastUpdatedBy }}</div>
      <div class="bodyContentSectionField">{{ crosswalk.lastUpdate }}</div>
    </div>
  </div>
</template>

<script>

export default {

  props: {
    crosswalk: {
      type: Object,
      required: true,
    },
  },

  computed: {
    lastUpdatedBy() {
      let lstUpdtBy = 'unknown';
      // eslint-disable-next-line
      if (this.crosswalk.lastUpdatedBy) lstUpdtBy = this.crosswalk.lastUpdatedBy.split('@')[0];
      return lstUpdtBy;
    },
  },
};
</script>

<style>

#modalBodyScroll {
  flex: 1;
  overflow-y: auto;
  padding-top: 12px;
}

#modalBodyTable {
    width: 100%;
    padding-left: 24px;
    padding-right: 24px;
}

#notesSection {
  text-align: left;
  padding-left: 26px;
  padding-right: 26px;
  padding-top: 12px;
  padding-top: 12px;
}

#notesHeader {
  font-weight: 500;
  padding-bottom: 12px;
}

.bodyContentSection {
  text-align: left;
  padding-left: 26px;
  padding-right: 26px;
  padding-top: 12px;
  padding-top: 12px;
}

.bodyContentSectionHeader {
  font-weight: 500;
  padding-bottom: 12px;
}

#linksBar {
  margin-top: 14px;
  margin-bottom: 14px;
}

tbody>tr>:nth-child(1){
 width:200px;
 text-align:left;
 font-weight: 500;
}

tbody>tr>:nth-child(2){
 text-align:right;
}
</style>
